import React, { useCallback, useReducer } from "react";
import ConfirmationDialog from "../components/ConfirmationDialog";
import { notBlank } from "../util/ext";

const actionTypes = {
  show: "show",
  confirm: "confirm",
  cancel: "cancel",
};

const confirmationReducer = (confirm, action) => {
  switch (action.type) {
    case actionTypes.show: {
      return { ...confirm, open: true };
    }
    case actionTypes.confirm: {
      return { ...confirm, open: false };
    }
    case actionTypes.cancel: {
      return { ...confirm, open: false };
    }
    default: {
      throw new Error(`Unhandled type in confirmReducer: ${action.type}`);
    }
  }
};

const useConfirmation = ({
  title = "Confirmation",
  message = "Confirm",
  confirmButtonText = "Ok",
  onCancel = null,
  onConfirm = null,
  reducer = confirmationReducer,
} = {}) => {
  const [confirm, dispatch] = useReducer(reducer, {
    open: false,
  });

  const showConfirmation = useCallback(() => {
    dispatch({
      type: actionTypes.show,
    });
  }, []);

  const handleCancel = useCallback(() => {
    if (notBlank(onCancel)) {
      onCancel();
    }
    dispatch({ type: actionTypes.cancel });
  }, [onCancel]);

  const handleConfirm = useCallback(() => {
    if (notBlank(onConfirm)) {
      onConfirm();
    }
    dispatch({ type: actionTypes.confirm });
  }, [onConfirm]);

  const WrappedConfirmationDialog = React.forwardRef((props, ref) => (
    <ConfirmationDialog
      confirmButtonText={confirmButtonText}
      message={message}
      title={title}
      visible={confirm.open}
      onCancel={handleCancel}
      onConfirm={handleConfirm}
      {...props}
      ref={ref}
    />
  ));

  return {
    showConfirmation,
    ConfirmationDialog: WrappedConfirmationDialog,
  };
};

export { useConfirmation, actionTypes };
